import React from 'react';
var NotFound = function () {
    return (React.createElement("div", null,
        React.createElement("div", null, "Page Not Found")));
};
export { NotFound };
//# sourceMappingURL=NotFound.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/NotFound.js
// module id = 1224
// module chunks = 0